import React from "react";
import { injectIntl } from "react-intl";
import { Badge } from "react-bootstrap";
import { CHAT_STATE, CHAT_DEFAULT_SUBJECT } from "./constants.js";
import ConversationsList from "./ConversationsList";
import MainBtn from "./MainBtn";
import Conversation from "./Conversation";
import MenuBar from "./MenuBar";
import NewGroupContainer from "./NewGroupContainer";
import NewConversationContainer from "./NewConversationContainer";
import { inject, observer } from "mobx-react";
import Loading from "./Loading";

let DevTools;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  DevTools = require('mobx-react-devtools').default;
} else {
  DevTools = () => null;
}

@injectIntl
@inject("uiStore", "conversationsStore")
@observer
class IgChat extends React.Component {
  /*************** RENDERING FUNCTIONS ******************/
  render() {
    const { uiStore } = this.props;
    return (
      <div className="conversations-widget">
        {this.renderAccordingToContainerState()}
        <div style={{ textAlign: "right" }}>
          {this.renderUnreadConversationsBadge()}
          <button title={this.props.intl.formatMessage({id: 'chat_title'})} style={{ fontSize: '25px', color: 'white' }}
            type="button" className="launcher" onClick={() => uiStore.toggleShow()}>
            {uiStore.minimized ?
              <i className="fa fa-comments open-launcher" /> :
              <i className="fa fa-remove close-launcher" />
            }
          </button>
          {/*<DevTools />*/}
        </div>
      </div>
    );
  }

  renderAccordingToContainerState() {
    let elementToRender;
    const { uiStore } = this.props;
    switch (uiStore.viewState) {
      case CHAT_STATE.MINIMIZED:
        elementToRender = this.renderMinimized();
        break;
      case CHAT_STATE.LOADING:
        elementToRender = <Loading />;
        break;

      case CHAT_STATE.CONVERSATION:
        elementToRender = this.renderCurrentConversation();
        break;

      case CHAT_STATE.NEW_CONVERSATION_FORM:
        elementToRender = this.renderNewConversationForm();
        break;

      case CHAT_STATE.NEW_GROUP_FORM:
        elementToRender = this.renderNewGroupForm();
        break;

      case CHAT_STATE.CONVERSATIONS_LIST:
      default:
        elementToRender = this.renderConversationsList();
        break;
    }
    return (
      <div className={uiStore.minimized ? "" : "conversations-container"}>
        {uiStore.showMenuBar && (
          <MenuBar
            onClickBack={() => uiStore.handleClickBack()}
            title={uiStore.menuBarTitle}
            showBackBtn={uiStore.showBackBtn}
          />
        )}
        {elementToRender}
      </div>
    );
  }

  renderMinimized() {
    return null;
  }

  renderUnreadConversationsBadge() {
    const unreadCount = this.props.conversationsStore.unreadConversationsCount;
    if (unreadCount > 0) {
      return (
        <Badge className="unread-conversations-badge">{unreadCount}</Badge>
      );
    }
    return null;
  }

  renderCurrentConversation() {
    let conversation = this.props.conversationsStore.currentConversation;
    return <Conversation conversation={conversation} />;
  }

  renderConversationsList() {
    return (
      <div>
        <ConversationsList />
        <MainBtn
          onClick={() => this.props.uiStore.handleNewConversationBtnClick()}
          glyphicon="pencil"
        />
      </div>
    );
  }

  renderNewConversationForm() {
    return <NewConversationContainer />;
  }

  renderNewGroupForm() {
    return <NewGroupContainer />;
  }
  /************* END RENDERING FUNCTIONS *******************/
}

export default injectIntl(IgChat);
